<template>
    <div class="cover-container">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="container-banner">
                        <HeadLine/>
                        <HeadingVideo/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeadLine from './HeadLine'
import HeadingVideo from './HeadingVideo'
export default {
    name: 'Heading',
    components: {
        HeadLine,
        HeadingVideo
    },
}
</script>

<style lang="scss">
div.cover-container  {
    background: url(https://firebasestorage.googleapis.com/v0/b/crossprom-staging.appspot.com/o/img%2FParallax%2FGroup%208.png?alt=media&token=c712499f-5672-4d55-bf25-c8ee69adb921) no-repeat;
    background-size: cover;
    height: 529px;
    padding-top: 70px;
    
    &:hover {
        div.container-banner {
            div.cover-video {
                img {
                        &.cycle {
                        top: -16px;
                        left: -17px;
                        z-index: 1;
                    }
                    &.mask {
                        top: 25px;
                        left: 39px;
                    }
                    &.owl {
                        top: 67px;
                        right: 153px;
                    }
                    &.pico {
                        top: 17px;
                        right: 28px;
                    }
                    &.vaze {
                        bottom: 12px;
                        left: 112px;
                    }
                    &.hd {
                        bottom: -24px;
                        left: 10px;
                    }
                    &.ciga {
                        bottom: -39px;
                        left: 102px;
                    }
                    &.rob {
                        bottom: -18px;
                        right: 150px;
                    }
                    &.small {
                        bottom: -13px;
                        right: 97px;
                    }
                    &.w {
                        bottom: 0;
                        right: -22px;
                    }
                }    
            }
        }        
    }
    div.container-banner {
        display: flex;
        justify-content: space-between;

        
    }
}
</style>